import { render } from "./remarkModel.vue?vue&type=template&id=8d838990"
import script from "./remarkModel.vue?vue&type=script&lang=js"
export * from "./remarkModel.vue?vue&type=script&lang=js"

import "./remarkModel.vue?vue&type=style&index=0&id=8d838990&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__